import { motion } from "framer-motion";

const personas = [
  {
    tag: "Dual-Income",
    title: "The two-career household.",
    body: "Two jobs, two calendars, one overlapping load nobody has time to name.",
  },
  {
    tag: "Chronic Illness",
    title: "Living with fluctuating capacity.",
    body: "Good days, bad days, and appointments that reshape the whole week.",
  },
  {
    tag: "Single Parent",
    title: "One tower. One person on watch.",
    body: "Every backup is you. Recovery is not a luxury — it's the mission.",
  },
  {
    tag: "Sandwich Generation",
    title: "Caring in both directions.",
    body: "Kids upstairs, aging parents on the phone, and you in the middle holding the line.",
  },
  {
    tag: "Military / Veteran",
    title: "Deployments, transitions, PCS moves.",
    body: "A household that reorients often — and needs a tower that reorients with it.",
  },
  {
    tag: "Underserved",
    title: "Doing more with less.",
    body: "Fewer backups, thinner buffers, and complexity nobody built a tool for. Until now.",
  },
];

export default function Personas() {
  return (
    <section
      id="personas"
      data-testid="personas-section"
      className="relative border-t border-rule py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl">
          <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-teal">
            04 — The families
          </p>
          <h2 className="mt-6 font-display text-4xl leading-[1.05] text-ink md:text-5xl">
            Built for the households
            <br />
            <span className="italic text-mist">the market forgot.</span>
          </h2>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {personas.map((p, i) => (
            <motion.article
              key={p.tag}
              data-testid={`persona-card-${p.tag.toLowerCase().replace(/[^a-z]/g, "-")}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.6,
                delay: (i % 3) * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="group relative border border-rule bg-deep/40 p-8 transition-colors duration-500 hover:border-teal/50"
            >
              <span className="absolute -top-px -left-px h-3 w-3 border-t border-l border-teal/70" />
              <span className="absolute -bottom-px -right-px h-3 w-3 border-b border-r border-teal/70" />
              <span className="inline-block border border-rule px-2 py-1 font-mono text-[10px] uppercase tracking-[0.22em] text-mist">
                {p.tag}
              </span>
              <h3 className="mt-6 font-display text-2xl leading-snug text-ink">
                {p.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-mist">
                {p.body}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
